<!-- <div class="pageContent bodyBg py-3">

</div> -->

<div class="pageContent py-3 px-4">
     <div class="row">
          <div class="col-md-9">
               <div class="card px-3 py-2 mb-3">
                    <div class="defaultTabs">
                         <div class="container-fluid">
                              <div class="row">
                                   <div class="col-md-12">
                                        <div class="title-lg text-primary font-weight-bold">
                                             <img src="./assets/images/resources.png" alt="resources"> &nbsp;Resources
                                        </div>
                                   </div>
                              </div>
                              <div class="row">
                                   <div class="col-md-6 col-sm-12 pt-2"
                                        *ngFor="let resource of resourcesList; let i = index">
                                        <div class="card resourceCard p-1">
                                             <div class="px-2 py-2 pointer zindex-1"
                                                  (click)="openConfirmationPopup(resource)">
                                                  <p class="font-weight-bold fs-15 zindex-1">{{resource.Resource_Name}}
                                                  </p>
                                                  <p class="fs-13 pt-1 zindex-1">{{resource.Resource_Desc}}</p>
                                             </div>
                                        </div>
                                   </div>

                              </div>
                         </div>

                    </div>
               </div>
          </div>
          <div class="col-md-3">
               <div class="row">
                    <app-promotional-cards></app-promotional-cards>
               </div>
          </div>
     </div>
</div>